export default "__VITE_ASSET__CghEUQx5__"